'use strict';

/**
 *
 * @name: nnFooterMain
 *
 */

import DirectiveTemplate from './nn-footer-main.directive.html';
import './nn-footer-main.directive.scss';

function NnFooterMainDirective() {

  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    template: DirectiveTemplate,
    scope: true,
    controller($scope) {
      'ngInject'; // jshint ignore:line

      $scope.currentYear = new Date().getFullYear()
    }
  };
}

export default NnFooterMainDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-footer-main/nn-footer-main.directive.js